module.exports = __webpack_public_path__ + "img/file-spreadsheet-fill.3d93fc6b.svg";